/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import SourceDTO from './SourceDTO';
import UInt64DTO from './UInt64DTO';





/**
* The TransactionStatementDTO model module.
* @module model/TransactionStatementDTO
* @version 0.7.15
*/
export default class TransactionStatementDTO {
    /**
    * Constructs a new <code>TransactionStatementDTO</code>.
    * The collection of receipts related to a transaction.
    * @alias module:model/TransactionStatementDTO
    * @class
    * @param height {module:model/UInt64DTO} 
    * @param source {module:model/SourceDTO} 
    * @param receipts {Array.<Object>} The array of receipts.
    */

    constructor(height, source, receipts) {
        

        
        

        this['height'] = height;this['source'] = source;this['receipts'] = receipts;

        
    }

    /**
    * Constructs a <code>TransactionStatementDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TransactionStatementDTO} obj Optional instance to populate.
    * @return {module:model/TransactionStatementDTO} The populated <code>TransactionStatementDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TransactionStatementDTO();

            
            
            

            if (data.hasOwnProperty('height')) {
                obj['height'] = UInt64DTO.constructFromObject(data['height']);
            }
            if (data.hasOwnProperty('source')) {
                obj['source'] = SourceDTO.constructFromObject(data['source']);
            }
            if (data.hasOwnProperty('receipts')) {
                obj['receipts'] = ApiClient.convertToType(data['receipts'], [Object]);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/UInt64DTO} height
    */
    height = undefined;
    /**
    * @member {module:model/SourceDTO} source
    */
    source = undefined;
    /**
    * The array of receipts.
    * @member {Array.<Object>} receipts
    */
    receipts = undefined;








}


